import React from "react";

const AddNotice = (props) => {
  return (
    <div className="addNotice">
      <button className="close"
        onClick={() => {
          props.close(false);
        }}
      >
        Close
      </button>
      {props.children}
    </div>
  );
};

export default AddNotice;
